function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useMemo, useState } from 'react';
import styles from './CheckboxTreeInput.module.scss';
import en from './locales/CheckboxInputTree.en.json';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
import ChevronCaret from '../../Icons/ChevronCaret/ChevronCaret';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import cs from 'classnames';
var DEFAULT_VALUE = {};
var messages = normalizeLocaleData(en, '@dm/components.checkbox-tree-input');
export function calculateAllChecked(nodeChildren, value) {
  return nodeChildren.reduce(function (acc, child) {
    var childValue = value[child.id];
    if (!acc || !childValue) {
      return false;
    }
    if (child.children) {
      return calculateAllChecked(child.children, childValue);
    }
    return true;
  }, true);
}
export function calculateAnyChecked(nodeChildren, value) {
  if (!value) {
    return false;
  }
  return !!nodeChildren.find(function (child) {
    var childValue = value[child.id];
    if (true === childValue) {
      return true;
    }
    if (child.children) {
      return calculateAnyChecked(child.children, childValue);
    }
    return false;
  });
}
export function fillValue(nodeChildren, value) {
  return nodeChildren.reduce(function (acc, child) {
    acc[child.id] = child.children ? fillValue(child.children, value) : value;
    return acc;
  }, {});
}
function Checkbox(_ref) {
  var checked = _ref.checked,
    id = _ref.id,
    index = _ref.index,
    label = _ref.label,
    onChange = _ref.onChange,
    _ref$partial = _ref.partial,
    partial = _ref$partial === void 0 ? false : _ref$partial,
    size = _ref.size;
  return /*#__PURE__*/React.createElement("span", {
    className: styles.checkbox
  }, /*#__PURE__*/React.createElement("span", {
    className: "_dm-input-container _dm-input-container--small _dm-input-container--checkbox _dm-input-container--dm _dm-input-container--dm--small"
  }, /*#__PURE__*/React.createElement("input", {
    "aria-labelledby": "".concat(id, "-label"),
    "aria-posinset": index,
    "aria-setsize": size,
    checked: checked,
    className: cs("_dm-input _dm-input--small", "_dm-input--boolean _dm-input--boolean--small", "_dm-input--checkbox _dm-input--checkbox--small", "_dm-input--ripple--boolean _dm-input--ripple--boolean--small", "_dm-input--ripple--checkbox _dm-input--ripple--checkbox--small", "auto-boolean-input auto-checkbox-input"),
    id: id,
    onChange: onChange,
    type: "checkbox",
    value: checked
  }), /*#__PURE__*/React.createElement("label", {
    id: "".concat(id, "-label"),
    htmlFor: id,
    className: cs(_defineProperty({}, styles.partial, partial && !checked), "_dm-label", "_dm-label--small", "_dm-label--checkbox", "_dm-label--checkbox--small", "_dm-label--label", "_dm-label--label--small", "_dm-label--ripple--label", "_dm-label--ripple--label--small", "_dm-label--ripple", "_dm-label--ripple--small", "_dm-label--ripple--checkbox", "_dm-label--ripple--checkbox--small", "_dm-label-layout", "_dm-label-layout--small", "_dm-label-layout--dm", "_dm-label-layout--dm--small", "_dm-label--boolean", "_dm-label--boolean--small", "_dm-label--ripple--boolean", "_dm-label--ripple--boolean--small", "auto-label-container")
  }, /*#__PURE__*/React.createElement("span", {
    className: "_dm-label__inner"
  }, /*#__PURE__*/React.createElement("span", {
    className: "auto-label"
  }, label)))));
}
function Leaf(_ref2) {
  var id = _ref2.id,
    index = _ref2.index,
    label = _ref2.label,
    onChange = _ref2.onChange,
    size = _ref2.size,
    value = _ref2.value;
  var handleChange = useCallback(function (e) {
    onChange(id, e.target.checked);
  }, [id, onChange]);
  return /*#__PURE__*/React.createElement("li", {
    className: styles['leaf']
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: value,
    id: id,
    index: index,
    label: label,
    onChange: handleChange,
    size: size
  }));
}
function Branch(_ref3) {
  var index = _ref3.index,
    node = _ref3.node,
    onChange = _ref3.onChange,
    size = _ref3.size,
    value = _ref3.value;
  var _useState = useState(function () {
      return calculateAnyChecked(node.children, value) && !calculateAllChecked(node.children, value);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var handleToggleExpanded = useCallback(function () {
    return setExpanded(!expanded);
  }, [expanded]);
  var checked = useMemo(function () {
    return calculateAllChecked(node.children, value);
  }, [node.children, value]);
  var partial = useMemo(function () {
    return calculateAnyChecked(node.children, value);
  }, [node.children, value]);
  var handleToggleChecked = useCallback(function () {
    onChange(node.id, fillValue(node.children, !checked));
    setExpanded(true);
  }, [onChange, node.id, node.children, checked]);
  var handleChange = useCallback(function (value) {
    onChange(node.id, value);
  }, [node.id, onChange]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BranchHeader, {
    checked: checked,
    expanded: expanded,
    index: index,
    node: node,
    onToggleChecked: handleToggleChecked,
    onToggleExpanded: handleToggleExpanded,
    partial: partial,
    size: size
  }), expanded && /*#__PURE__*/React.createElement(BranchChildren, {
    childNodes: node.children,
    className: styles['branch-children'],
    key: node.id,
    onChange: handleChange,
    value: value
  }));
}
function BranchHeader(_ref4) {
  var checked = _ref4.checked,
    expanded = _ref4.expanded,
    index = _ref4.index,
    node = _ref4.node,
    onToggleChecked = _ref4.onToggleChecked,
    onToggleExpanded = _ref4.onToggleExpanded,
    partial = _ref4.partial,
    size = _ref4.size;
  var i18n = useMemo(function () {
    return {
      id: "@dm/components.checkbox-tree-input.".concat(expanded ? 'collapse' : 'expand'),
      values: {
        value: node.label
      }
    };
  }, [node.label, expanded]);
  return /*#__PURE__*/React.createElement("li", {
    "aria-expanded": expanded ? 'true' : 'false',
    className: styles['branch-header']
  }, /*#__PURE__*/React.createElement("button", {
    className: "".concat(styles.chevron, " ").concat(styles.button),
    onClick: onToggleExpanded,
    type: "button"
  }, /*#__PURE__*/React.createElement(ChevronCaret, {
    direction: expanded ? 'down' : 'right',
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement(ButtonLabel, {
    i18n: i18n,
    hideLabel: true
  })), /*#__PURE__*/React.createElement(Checkbox, {
    checked: checked,
    id: "".concat(node.id, "-check-all"),
    index: index,
    label: node.label,
    onChange: onToggleChecked,
    partial: partial,
    size: size
  }));
}
function BranchChildren(_ref5) {
  var childNodes = _ref5.childNodes,
    className = _ref5.className,
    onChange = _ref5.onChange,
    value = _ref5.value;
  var handleItemChange = useCallback(function (id, checked) {
    onChange(Object.assign({}, value, _defineProperty({}, id, checked)));
  }, [onChange, value]);
  var handleTreeChange = useCallback(function (id, childValue) {
    onChange(Object.assign({}, value, _defineProperty({}, id, childValue)));
  }, [onChange, value]);
  return /*#__PURE__*/React.createElement("ul", {
    className: className
  }, childNodes.map(function (node, index) {
    return node.children ? /*#__PURE__*/React.createElement(Branch, {
      index: index + 1,
      key: node.id,
      node: node,
      onChange: handleTreeChange,
      size: childNodes.length,
      value: value[node.id] || DEFAULT_VALUE
    }) : /*#__PURE__*/React.createElement(Leaf, {
      id: node.id,
      index: index + 1,
      key: node.id,
      label: node.label,
      onChange: handleItemChange,
      size: childNodes.length,
      value: value[node.id]
    });
  }));
}
export default function CheckboxTreeInput(_ref6) {
  var onChange = _ref6.onChange,
    structure = _ref6.structure,
    value = _ref6.value;
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: messages,
    namespace: "@dm/components.checkbox-tree-input"
  }, /*#__PURE__*/React.createElement(BranchChildren, {
    childNodes: structure,
    className: styles['tree'],
    onChange: onChange,
    value: value
  }));
}